// @flow
import React from 'react';

import MatchStats from 'components/rencontre/MatchStats';
import EmptyState from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchEmptyState';

// import './CompetitionsInternationalesSingleMatchStats.css';
type Props = {
  rencontre: any
};

function CompetitionsInternationalesSingleMatchStats({ rencontre }: Props) {
  const {
    meta: { reception, equipeNom, adversaire, afficher_stats }
  } = rencontre;

  let showStats = !!afficher_stats;
  if (showStats) {
    showStats = rencontre.faits_de_jeu.length > 0;
    if (!showStats)  {
      showStats = rencontre.france_nb_cartons_jaunes > 0 || 
        rencontre.france_nb_cartons_rouges > 0 || 
        rencontre.france_nb_drops > 0 || 
        rencontre.france_nb_essais > 0 || 
        rencontre.france_nb_penalites > 0 || 
        rencontre.france_nb_transformations > 0 || 
        rencontre.adversaire_nb_cartons_jaunes > 0 ||
        rencontre.adversaire_nb_cartons_rouges > 0 ||
        rencontre.adversaire_nb_drops > 0 ||
        rencontre.adversaire_nb_essais > 0 ||
        rencontre.adversaire_nb_penalites > 0 ||
        rencontre.adversaire_nb_transformations > 0;
    }
  }

  let classes = 'container single-match__stats';
  if (!showStats) {
    classes = `${classes} with-empty-state`;
  }
  
  return (
    <article className={classes}>
      {!showStats && (
        <EmptyState
          titleFirstPart="Statistiques"
          titleSecondPart="du match"
          description="Les statistiques du match seront disponibles très prochainement."
          backgroundImage="/img/empty-state-statistiques.png"
        />
      )}
      {showStats &&
      <MatchStats reception={reception} equipeNom={equipeNom} adversaire={adversaire} rencontreData={rencontre} />}
    </article>
  );
}

export default CompetitionsInternationalesSingleMatchStats;
